<!-- eslint-disable vue/require-v-for-key -->
<template>
  <v-card elevation="1" class="pa-3">
    <v-row>
      <v-col class="pb-2" cols="12" md="6">
        <label class="text-h6">Carrinho</label>
      </v-col>
      <v-col class="pb-2" cols="12" md="3">
        <v-btn
          color="green"
          small
          dark
          left
          style="float: right"
          @click="goToListProducts()"
        >
          <v-icon left>mdi-plus</v-icon>
          Adicionar Novo Item
        </v-btn>
      </v-col>
      <v-col class="pb-2" cols="12" md="3">
        <v-btn
          color="black"
          outlined
          @click="goToDetailPage()"
          left
          small
          dark
          style="float: right"
        >
          <v-icon left>mdi-chevron-left</v-icon>
          Voltar
        </v-btn>
      </v-col>
    </v-row>
    <v-radio-group v-model="radioGroup">
      <v-row v-if="true">
        <v-col cols="12" md="9">
          <v-row v-for="provider in cart.providers" :key="provider.provider_id">
            <v-col>
              <v-row>
                <v-col>
                  <label class="black--text">
                    <v-radio
                      :value="provider.provider_id"
                      :label="`${provider.provider_code} - ${provider.provider_name}`"
                    ></v-radio>
                    <!-- 0248 - PG4 -->
                  </label>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="text-left">
                  <strong class="subtitle-2 black--text"
                    >Total:
                    {{ getTotalProvider(provider) | currencyEuaToBr }}</strong
                  >
                </v-col>
                <v-col class="text-left">
                  <strong class="subtitle-2 black--text">
                    Quantidade: {{ getQuantityProvider(provider) }}
                  </strong>
                </v-col>
                <v-col class="text-left">
                  <strong class="subtitle-2 red--text">
                    Frete CIF {{ 3000 | currencyEuaToBr }}
                  </strong>
                  <v-icon right color="red darken-1">
                    mdi-close-circle-outline
                  </v-icon>
                </v-col>
                <v-col class="text-left">
                  <strong class="subtitle-2 green--text">
                    Pedido Mínimo {{ 2000 | currencyEuaToBr }}
                  </strong>
                  <v-icon right color="green darken-1">
                    mdi-checkbox-marked-circle-outline
                  </v-icon>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0">
                  <v-divider></v-divider>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="mt-1">
                  <v-simple-table fixed-header height="300">
                    <template v-slot:default>
                      <tbody>
                        <tr
                          v-for="(item, index) in provider.products"
                          :key="`${item.reference}${item.color_code}${item.material_code}`"
                        >
                          <td class="text-center text-h6" width="40px">
                            {{ index + 1 }}
                          </td>
                          <td width="30%">
                            <div class="d-flex align-items-center">
                              <v-img
                                :src="item.image"
                                max-width="120"
                                contain
                                :aspect-ratio="16 / 9"
                                class="my-2 image-clickable"
                                @click="
                                  onClickImage(
                                    item.image,
                                    item.reference,
                                    item.name
                                  )
                                "
                              />
                              <div class="ma-3 mt-5">
                                <p class="mb-1">
                                  {{ item.name }}
                                </p>
                                <p class="mb-1">
                                  <label class="font-weight-bold"
                                    >Referência:</label
                                  >
                                  {{ item.provider_code }}{{ item.reference }}
                                </p>
                                <p class="mb-1">
                                  <label class="font-weight-bold"
                                    >Material:</label
                                  >
                                  {{ item.material_code }} -
                                  {{ item.material_name }}
                                </p>
                                <p class="mb-1">
                                  <label class="font-weight-bold">Cor:</label>
                                  {{ item.color_code }} - {{ item.color_name }}
                                </p>
                                <p class="mb-0">
                                  <label class="caption font-weight-black">
                                    {{ item.collection }}
                                  </label>
                                </p>
                              </div>
                            </div>
                          </td>
                          <td width="31%">
                            <div class="d-flex align-items-center">
                              <div class="ma-3">
                                <div class="mb-0">
                                  <label class="font-weight-bold">Grade:</label>
                                  <table class="table-grid-cart">
                                    <tbody>
                                      <tr class="">
                                        <td
                                          colspan="7"
                                          class="none-border-bottom"
                                        >
                                          <div
                                            class="box-grid"
                                            v-for="size in item.grid"
                                            :key="size"
                                          >
                                            {{ size }}
                                          </div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td colspan="7">
                                          <div
                                            class="box-quantity"
                                            v-for="size in item.qtys"
                                          >
                                            {{ size }}
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </td>
                          <td width="12%">
                            <div class="d-flex align-items-center">
                              <div class="ma-3">
                                <p class="mb-1">
                                  <label class="font-weight-bold"
                                    >Qtde. Grade:</label
                                  ><br />
                                  {{ getCountTotal(item) }}
                                </p>
                                <p class="mb-1">
                                  <label class="font-weight-bold"
                                    >Categoria:</label
                                  ><br />
                                  {{ item.category_name }}
                                </p>
                                <p class="mb-1">
                                  <label class="font-weight-bold"
                                    >Subcategoria:</label
                                  ><br />
                                  {{ item.subcategory_name }}
                                </p>
                                <p class="mb-0">
                                  <v-chip
                                    v-if="item.release"
                                    color="green"
                                    label
                                    text-color="white"
                                  >
                                    <v-icon left> mdi-label </v-icon>
                                    Lançamento
                                  </v-chip>
                                  <!-- <label class="caption font-weight-black">
                                      {{ item.collection }}
                                    </label> -->
                                </p>
                              </div>
                            </div>
                          </td>
                          <td width="12%">
                            <div class="d-flex align-items-center">
                              <div class="ma-3">
                                <p class="mb-1">
                                  <label class="font-weight-bold"
                                    >Valor Original:</label
                                  ><br />
                                  {{ item.price_cif | currencyEuaToBr }}
                                </p>
                                <p class="mb-1">
                                  <label class="font-weight-bold"
                                    >Valor Unitário:</label
                                  ><br />
                                  {{ item.price_cif | currencyEuaToBr }}
                                </p>
                                <p class="mb-1">
                                  <label class="font-weight-bold">
                                    Total: </label
                                  ><br />
                                  {{ getTotal(item) | currencyEuaToBr }}
                                </p>
                                <p class="mb-0">
                                  <v-tooltip
                                    bottom
                                    color="error"
                                    dark
                                    v-if="false"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-alert
                                        border="left"
                                        color="red lighten-2"
                                        dark
                                        dense
                                        text
                                        v-bind="attrs"
                                        v-on="on"
                                      >
                                        <label
                                          class="font-weight-black caption"
                                        >
                                          Coleção não atual
                                        </label>
                                      </v-alert>
                                    </template>
                                    <span>
                                      Este produto não é da coleção atual,
                                      sujeito a alteração de preço e
                                      disponibilidade.
                                    </span>
                                  </v-tooltip>
                                </p>
                              </div>
                            </div>
                          </td>
                          <td
                            style="min-width: 80px !important"
                            class="text-right"
                          >
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  color="blue darken-3"
                                  class="mr-2"
                                  v-bind="attrs"
                                  v-on="on"
                                  @click="handleEditProduct(item)"
                                >
                                  mdi-pencil
                                </v-icon>
                              </template>
                              <span>Editar Produto</span>
                            </v-tooltip>
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  color="red darken-3"
                                  v-bind="attrs"
                                  v-on="on"
                                  @click="handleDeleteProduct(item)"
                                >
                                  mdi-delete
                                </v-icon>
                              </template>
                              <span>Remover Produto</span>
                            </v-tooltip>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-divider class="mt-3 mb-3"></v-divider>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <!-- </v-card> -->
        </v-col>
        <v-divider inset vertical></v-divider>
        <v-col cols="12" md="3">
          <!-- <v-card elevation="1" class="pa-3"> -->
          <v-row>
            <v-col class="py-1">
              <label class="text-h5">Total</label>
              <v-divider></v-divider>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0">
              <label class="subtitle-2">Fornecedor: </label>
            </v-col>
            <v-col cols="12" xs="12" class="py-0 text-left">
              <label class="subtitle-1 font-weight-bold">
                {{ providerSelected.provider_code }} -
                {{ providerSelected.provider_name.toString().substring(0, 16) }}
              </label>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0">
              <label class="subtitle-2">Produtos:</label>
            </v-col>
            <v-col class="py-0 text-right">
              <label class="subtitle-1">
                {{ providerSelected.products.length }}
              </label>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0">
              <label class="subtitle-2">Quantidade:</label>
            </v-col>
            <v-col class="py-0 text-right">
              <label class="subtitle-1">
                {{ getQuantityProvider(providerSelected) }}
              </label>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0">
              <label class="subtitle-2">Total:</label>
            </v-col>
            <v-col class="py-0 text-right">
              <label class="subtitle-1">
                {{ getTotalProvider(providerSelected) | currencyEuaToBr }}
              </label>
            </v-col>
          </v-row>
          <v-row v-if="pageOrigin === 'express'">
            <v-col>
              <v-row>
                <v-col xs="0" md="1"></v-col>
                <v-col xs="12" md="10" class="py-2">
                  <label>Frete/Transportadora:</label><br />
                  <label class="font-weight-bold">
                    <v-select
                      :items="shippings"
                      v-model="shipping"
                      hide-details
                      dense
                      outlined
                    ></v-select>
                  </label>
                </v-col>
              </v-row>
              <v-row>
                <v-col xs="0" md="1"></v-col>
                <v-col xs="12" md="10" class="py-2">
                  <label>Pagamento:</label><br />
                  <label class="font-weight-bold">
                    <v-select
                      :items="payment_conditions"
                      :item-text="(item) => `${item.name}`"
                      item-value="id"
                      v-model="payment_condition"
                      hide-details
                      dense
                      outlined
                    ></v-select>
                  </label>
                </v-col>
              </v-row>
              <v-row>
                <v-col xs="0" md="1"></v-col>
                <v-col xs="12" md="10" class="py-0">
                  <label class="font-weight-bold"> Observações </label>
                  <v-textarea
                    outlined
                    counter
                    rows="4"
                    no-resize
                    row-height="30"
                    name="print-observation"
                    class="text-field-uppercase"
                    v-model="observation"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn
                color="blue"
                dark
                block
                style="float: right"
                @click="
                  saveOrder(this.providerSelected, {
                    shipping,
                    payment_condition,
                    observation,
                  })
                "
              >
                <v-icon left>mdi-cart-outline</v-icon>
                Finalizar Pedido
              </v-btn>
            </v-col>
          </v-row>
          <!-- </v-card> -->
        </v-col>
      </v-row>
    </v-radio-group>
  </v-card>
</template>

<script>
import * as CompanyAPI from "@/api/requests/CompanyRequest";
import * as ShippingAPI from "@/api/requests/ShippingRequest";
import { UF_REGIONS } from "@/api/constants";

export default {
  props: {
    cart: {},
    handleDeleteProduct: Function,
    handleEditProduct: Function,
    goToListProducts: Function,
    goToDetailPage: Function,
    onClickImage: Function,
    saveOrder: Function,
    pageOrigin: String,
  },
  data: () => ({
    radioGroup: "",
    providerSelected: {},
    shipping: "",
    shippings: [],
    payment_conditions: [],
    payment_condition: "",
    observation: "",
    conditions: {
      shipping: {
        value: "",
        type: "",
      },
      minimum_order: {
        value: "",
        type: "",
      },
    },
    conditionsReset: {
      shipping: {
        value: "",
        type: "",
      },
      minimum_order: {
        value: "",
        type: "",
      },
    },
  }),
  created() {
    if (this.cart.providers.length > 0) {
      if (this.pageOrigin === "express") {
        this.cart.providers.map(async (provider) => {
          this.conditions = { ...this.conditionsReset };
          this.shippings = [];
          await this.getShippings(provider.provider_id);
          return {
            ...provider,
            shippings: this.shippings,
            conditions: this.conditions,
          };
        });
        this.radioGroup = this.cart.providers[0].provider_id;
        this.providerSelected = this.cart.providers[0];

        if (this.pageOrigin === "express") {
          this.conditions = this.cart.providers[0].conditions;
          this.shippings = this.cart.providers[0].shippings;
        }
      }
    }
  },
  methods: {
    getTotal(item) {
      return this.getCountTotal(item) * parseFloat(item.price_cif);
    },
    getCountTotal(item) {
      return item.qtys.map((item) => parseInt(item)).reduce((a, b) => a + b);
    },
    getQuantityProvider(provider) {
      return provider.products
        .map((item) => this.getCountTotal(item))
        .reduce((a, b) => a + b);
    },
    getTotalProvider(provider) {
      return provider.products
        .map((item) => this.getTotal(item))
        .reduce((a, b) => parseFloat(a) + parseFloat(b));
    },
    handleSaveOrder() {
      console.log(this.providerSelected);
    },
    async getShippings(id) {
      // this.loading = true;
      try {
        let response = await ShippingAPI.getById(id);
        if (Object.keys(response).length === 0) {
          let company = await CompanyAPI.getById(id);
          this.conditions = {
            minimum_order: {
              type:
                company.type_minimum_order == null
                  ? ""
                  : company.type_minimum_order,
              value: company.minimum_order,
            },
            shipping: {
              type: "",
              value: "",
            },
          };
          this.shippings = this.shippings.filter(
            (item) => item.value !== "cif"
          );
        } else {
          this.conditions = {
            minimum_order: {
              value: response.company.minimum_order,
              type:
                response.company.type_minimum_order == null
                  ? ""
                  : response.company.type_minimum_order,
            },
            shipping: this.getShippingRules(response),
          };
        }
        // console.log(JSON.stringify(this.conditions));
      } catch (error) {
        console.log(error);
      }
    },
    getShippingRules(response) {
      let rule = {
        value: "",
        type: response.type,
      };
      let notEmpty = (value) => value !== null && value !== "";
      let state = this.order.franchise.delivery_state;

      if (notEmpty(state)) {
        if (response.states.length > 0 && rule.value === "") {
          let res = response.states.find((item) => item.name === state);
          if (res) {
            rule.value = res.minimum_order;
          }
        }

        if (response.regions.length > 0 && rule.value === "") {
          let detailState = UF_REGIONS.find((item) => item.value === state);
          let res = response.regions.find(
            (item) => item.name === detailState.region
          );
          if (res) {
            rule.value = res.minimum_order;
          }
        }
      }

      if (rule.value === "") {
        rule.value = response.minimum_order;
      }
      return rule;
    },
    getPayments() {},
  },
};
</script>

<style scoped>
.box-grid {
  background-color: #010101;
  color: white;
  padding: 6px;
  margin: 4px;
  width: 25px;
  font-size: 10px;
  height: 25px;
  display: inline-block;
  text-align: center;
  font-weight: bold;
}
.box-quantity {
  background-color: #dfdfdf;
  color: black;
  padding: 6px;
  margin: 4px;
  width: 25px;
  height: 25px;
  font-size: 10px;
  display: inline-block;
  text-align: center;
  font-weight: bold;
}
</style>
